export default __webpack_public_path__ + "static/media/workshop_02.b75ac939.jpg";